var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14Z",
    fill: "#D42216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8101 8.45961C12.1446 8.36724 12.5035 8.38259 12.8272 8.5031C13.1509 8.62362 13.4197 8.84203 13.589 9.12199L13.6455 9.22631L14.1516 10.2563C14.3052 10.5689 14.355 10.916 14.295 11.2543C14.2349 11.5927 14.0675 11.9074 13.8137 12.1594L13.712 12.2518L12.9147 12.9331C12.771 13.0577 12.8788 13.5401 13.3986 14.3649C13.8665 15.1071 14.2472 15.4537 14.4344 15.4726H14.4673L14.5078 15.4656L16.075 15.0266C16.2856 14.9674 16.5103 14.9651 16.7224 15.0199C16.9344 15.0746 17.1247 15.1842 17.2706 15.3354L17.3401 15.4159L18.3775 16.7322C18.5808 16.9903 18.6821 17.304 18.6648 17.6218C18.6474 17.9396 18.5124 18.2425 18.282 18.4806L18.1887 18.5688L17.7744 18.9287C17.4023 19.2514 16.9369 19.4695 16.4334 19.557C15.93 19.6445 15.4097 19.5978 14.9344 19.4223C13.4552 18.8762 12.1113 17.6285 10.8904 15.6918C9.6673 13.7502 9.15894 12.0578 9.38598 10.6085C9.45469 10.1703 9.65166 9.75744 9.95599 9.41361C10.2603 9.06978 10.6606 8.80786 11.1144 8.65567L11.262 8.61085L11.8101 8.45961Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneImg);
export default __webpack_public_path__ + "static/media/PhoneImg.60b9dbc8c651468aa9e4a6a9a94dac4b.svg";
export { ForwardRef as ReactComponent };